export const mock = {
  orchestratorServer: {
    baseUri: 'http://localhost:4000',
  },
};
